import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-919eb988"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_task" }
const _hoisted_2 = { class: "flexBetween" }
const _hoisted_3 = { class: "flexAlign" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("新建任务")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("批量创建任务")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("查看甘特图")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("只显示顶级任务")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("显示全部任务")
const _hoisted_9 = {
  class: "flexAlign",
  style: {"margin-left":"30px"}
}
const _hoisted_10 = { class: "header_nr flexAlign" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "状态：", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_13 = {
  class: "flexEnd",
  style: {"padding":"20px"}
}
const _hoisted_14 = { class: "my-header" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "新建任务", -1))
const _hoisted_16 = { class: "qp" }
const _hoisted_17 = { class: "my-header" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "任务详情", -1))
const _hoisted_19 = { class: "qp" }
const _hoisted_20 = { class: "my-header" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "批量创建任务", -1))
const _hoisted_22 = { class: "qp" }
const _hoisted_23 = { class: "my-header" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "项目甘特图", -1))

import { useRouter,useRoute } from 'vue-router';
	import { onMounted,ref,nextTick,computed,onBeforeUnmount,watch } from 'vue';
	import { requestTaskList } from '@/api/xmApi';
	import AddTask from '@/components/AddTask.vue';
	import TaskDetails from '@/components/TaskDetails.vue'
	import BatchAddTask from '@/components/BatchAddTask.vue';
	import GanttChart from '@/components/GanttChart.vue';
	import {requestgetselfrole } from '@/api/api';
	
export default /*#__PURE__*/_defineComponent({
  name: 'TaskList',
  setup(__props) {

	const router = useRouter()
	const route = useRoute()
	const userrole = ref<string>("")//用户角色
	const list = ref([])
	const loading = ref<boolean>(false)
	const addShowTask = ref<boolean>(false)//添加任务
	const addTask = ref<boolean>(false)
	const batchShowTask = ref<boolean>(false)//批量创建
	const batchTask = ref<boolean>(false)
	const ganttShow = ref<boolean>(false)//甘特图
	const ganttShowInner = ref<boolean>(false)
	const ganttKey = ref<number>(0)//甘特图重建 key（用 key 原地重建，保证每次打开都是全新实例）
// 弹窗关闭后卸载甘特图实例：避免再次打开时新实例与旧实例/dialog 过渡动画竞态，
// 触发 Vue 内部错误（insertBefore / Cannot destructure property 'bum' of null）
watch(ganttShow, (v: boolean) => {
	if (!v) ganttShowInner.value = false
})
	const taskDetails = ref(false)//控制右侧弹窗
	const taskDetailsShow = ref(false)//控制右侧弹窗
	const form = ref({})
	const taskid = ref(route.params.taskid)
	console.log(taskid.value)
	const yuqi =ref(route.params.yuqi);
	const pageIndex = ref<number>(1)
	const pageSize = ref<number>(10)
	const pages = ref({
		totalCount:0
	})
	const search = ref({
		status:0
	})
	// 0=显示全部任务；1=只显示顶级任务（无上级任务）
	const onlyTop = ref<number>(0)
	const setOnlyTop = (val: number) => {
		if(onlyTop.value === val) return
		onlyTop.value = val
		pageIndex.value = 1
		getTaskList()
	}
	// ===== 表头排序（服务端排序：分页列表若用客户端排序只会排当前页，故交由后端 ORDER BY）=====
	// 前端列 prop -> 后端排序字段标识（后端用白名单映射为真实列，避免 SQL 注入）
	const sortPropMap: {[key:string]: string} = {
		'cell.projectname': 'projectname',
		'cell.createname': 'createname',
		'cell.createtime': 'createtime',
		'cell.type1': 'type1',
		'cell.tasktitle': 'tasktitle',
		'cell.operatorname': 'operatorname',
		'cell.operatorplanendtime': 'operatorplanendtime',
		'cell.enddate': 'enddate',
		'cell.priority2': 'priority2',
		// 已读列显示"已读/未读"，排序依据是实际读取时间
		'cell.operatorreadtime1': 'operatorreadtime',
		'cell.checkname': 'checkname',
		'cell.status': 'status'
	}
	const sortField = ref<string>('')
	const sortOrder = ref<string>('') // asc / desc
	const handleSortChange = ({ prop, order }: any) => {
		if (!order) {
			// 取消排序：恢复默认顺序（按开始时间倒序）
			sortField.value = ''
			sortOrder.value = ''
		} else {
			sortField.value = sortPropMap[prop] || ''
			sortOrder.value = order === 'ascending' ? 'asc' : 'desc'
		}
		pageIndex.value = 1
		getTaskList()
	}
	const getStatus = computed(()=>{
		return function(status:number){
			let a = {
				1:"进行中",
				2:"关闭",
				3:"待审核",
				4:"完成",
				5:"逾期进行中",
				6:"逾期待审核"
			}
			return a[status]
		}
	})
	const getType = computed(()=>{
		return function(status:number){
			let b = {
				1:"primary",
				2:"danger",
				3:"warning",
				4:"success",
				5:"danger",
				6:"warning"
			}
			return b[status]
		}
	})
	// 列表行状态：结合任务截至时间(enddate)判断逾期
	const getRowStatus = (cell:any):number => {
		const status = cell.status ? Number(cell.status) : 0
		if (status === 1 || status === 3) {
			const end = cell.enddate ? String(cell.enddate).substring(0, 10) : ''
			const today = new Date().toISOString().slice(0, 10)
			if (end && end < today) {
				return status === 1 ? 5 : 6
			}
		}
		return status
	}
	// 合并“阶段”(type1) 相同的单元格：后台已按 type1 升序，相邻同值纵向合并
	const mergeType1 = ({ row, column, rowIndex }: any) => {
		if (column.property !== 'cell.type1') {
			return { rowspan: 1, colspan: 1 }
		}
		const cur = (row.cell && row.cell.type1) || ''
		if (cur === '') {
			return { rowspan: 1, colspan: 1 }
		}
		const data: any[] = list.value as any[]
		if (rowIndex > 0 && data[rowIndex - 1] && (data[rowIndex - 1].cell.type1 || '') === cur) {
			return { rowspan: 0, colspan: 0 }
		}
		let span = 1
		while (rowIndex + span < data.length && (data[rowIndex + span].cell.type1 || '') === cur) {
			span++
		}
		return { rowspan: span, colspan: 1 }
	}
	const cancelDetails = () => {
		taskDetails.value = false
		getTaskList()
	}
	const cancelTask = (val:any) =>{
		addShowTask.value = false
		if(val){
			getTaskList()
		}
	}
	//批量创建任务
	const batchCreateTask = () => {
		batchTask.value = false
		nextTick(()=>{
			batchTask.value = true
		})
		batchShowTask.value = true
	}
	//查看甘特图
	const showGantt = () => {
		ganttShowInner.value = true
		ganttKey.value++ // 换 key 让 GanttChart 原地重建并重新加载数据
		ganttShow.value = true
	}
	//甘特图点击任务，打开任务详情
	const openTaskFromGantt = (task:any) => {
		form.value = task
		taskDetailsShow.value = false
		nextTick(()=>{
			taskDetailsShow.value = true
		})
		taskDetails.value = true
	}
	const cancelBatchTask = (val:any) => {
		batchShowTask.value = false
		if(val){
			getTaskList()
		}
	}
	const searchList = () =>{
		pageIndex.value = 1
		getTaskList();
	}
	const details = (row:any) => {
		form.value = row.cell
		taskDetailsShow.value = false
		nextTick(()=>{
			taskDetailsShow.value = true
		})
		taskDetails.value = true
	}
	//刷新列表
	const taskListsx = () => {
		getTaskList()
		taskDetails.value = false
	}
	//新建任务
	const createTask = () => {
		tasksx()
		addShowTask.value = true
	}
	const tasksx = () => {
		addTask.value = false
		nextTick(()=>{
			addTask.value = true
		})
	}
	onMounted(()=>{
		requestgetselfrole().then((res:any)=>{
			if(res.status === 1){
				userrole.value = res.datalist
				console.log(userrole.value)
			}
		})
		getTaskList();
	})
	const getTaskList = () => {
		loading.value = true
		requestTaskList({
			pageIndex:pageIndex.value,
			pageSize:pageSize.value,
			projectid:taskid.value,
			status:search.value.status,
			yuqi:yuqi.value,
			onlytop:onlyTop.value,
			sortfield:sortField.value,
			sortorder:sortOrder.value
		}).then((res:any)=>{
			for(var i=0;i<res.data.length;i++){
				if(res.data[i].cell.operatorreadtime==""){
					res.data[i].cell.operatorreadtime1="未读"
				}else{
					res.data[i].cell.operatorreadtime1="已读"
				}
			}
			list.value = res.data
			pages.value.totalCount = res.totalCount
			loading.value = false
		})
	}
	const handleSizeChange = (val: number) =>{
		pageSize.value = val
		getTaskList();
	}
	const handleCurrentChange = (val: number) =>{
		pageIndex.value = val
		getTaskList();
	}
	const back = () =>{
		router.go(-1)
	}
	// 页面卸载前先关闭所有弹窗，避免带着打开状态的 el-dialog 整体卸载，
	// 触发 Vue 内部 transition 卸载竞态（Cannot destructure property 'bum' of null）
	onBeforeUnmount(() => {
		addShowTask.value = false
		addTask.value = false
		batchShowTask.value = false
		batchTask.value = false
		ganttShow.value = false
		ganttShowInner.value = false
		taskDetails.value = false
		taskDetailsShow.value = false
	})

return (_ctx: any,_cache: any) => {
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_page_header, {
          content: "任务列表",
          onBack: _cache[0] || (_cache[0] = ($event: any) => (back()))
        }),
        (userrole.value != '经销商')
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              size: "small",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (createTask())),
              style: {"margin-left":"30px"}
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (userrole.value != '经销商')
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "success",
              size: "small",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (batchCreateTask()))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          type: "warning",
          size: "small",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (showGantt()))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          size: "small",
          type: onlyTop.value === 1 ? 'primary' : 'default',
          plain: onlyTop.value !== 1,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (setOnlyTop(1)))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["type", "plain"]),
        _createVNode(_component_el_button, {
          size: "small",
          type: onlyTop.value === 0 ? 'primary' : 'default',
          plain: onlyTop.value !== 0,
          onClick: _cache[5] || (_cache[5] = ($event: any) => (setOnlyTop(0)))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["type", "plain"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_el_select, {
            onChange: _cache[6] || (_cache[6] = ($event: any) => (searchList())),
            modelValue: search.value.status,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((search.value.status) = $event)),
            size: "small",
            placeholder: "请选择",
            style: {"width":"150px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "未关闭",
                value: 0
              }),
              _createVNode(_component_el_option, {
                label: "进行中",
                value: 1
              }),
              _createVNode(_component_el_option, {
                label: "关闭",
                value: 2
              }),
              _createVNode(_component_el_option, {
                label: "提交待审核",
                value: 3
              }),
              _createVNode(_component_el_option, {
                label: "完成",
                value: 4
              }),
              _createVNode(_component_el_option, {
                label: "逾期进行中",
                value: 5
              }),
              _createVNode(_component_el_option, {
                label: "逾期待审核",
                value: 6
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])
    ]),
    _hoisted_12,
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      onCellClick: details,
      data: list.value,
      border: "",
      "span-method": mergeType1,
      "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'},
      onSortChange: handleSortChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          width: "80",
          label: "序号",
          align: "center",
          fixed: "left"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.type1",
          label: "阶段",
          width: "180",
          "show-overflow-tooltip": "",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.tasktitle",
          label: "任务标题",
          width: "250",
          "show-overflow-tooltip": "",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.operatorname",
          label: "执行人",
          width: "100",
          "show-overflow-tooltip": "",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.checkname",
          label: "审核人",
          width: "100",
          "show-overflow-tooltip": "",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.enddate",
          label: "要求完成时间",
          width: "140",
          "show-overflow-tooltip": "",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.status",
          label: "状态",
          width: "110",
          sortable: "custom"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              type: _unref(getType)(getRowStatus(scope.row.cell))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getStatus)(getRowStatus(scope.row.cell))), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        currentPage: pageIndex.value,
        "onUpdate:currentPage": _cache[8] || (_cache[8] = ($event: any) => ((pageIndex).value = $event)),
        "page-sizes": [10, 20, 30],
        "page-size": pageSize.value,
        "onUpdate:page-size": _cache[9] || (_cache[9] = ($event: any) => ((pageSize).value = $event)),
        layout: "total, sizes, prev, pager, next, jumper",
        total: pages.value.totalCount
      }, null, 8, ["currentPage", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      top: "5vh",
      modelValue: addShowTask.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((addShowTask).value = $event)),
      "show-close": false,
      "close-on-click-modal": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (addShowTask.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (addTask.value)
          ? (_openBlock(), _createBlock(AddTask, {
              key: 0,
              id: taskid.value,
              onCancelTask: cancelTask
            }, null, 8, ["id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_el_dialog, {
        modelValue: taskDetails.value,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((taskDetails).value = $event)),
        "show-close": false,
        fullscreen: ""
      }, {
        header: _withCtx(({ close, titleId, titleClass }) => [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_el_icon, {
              class: "delicon",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (cancelDetails()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Close)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          (taskDetailsShow.value)
            ? (_openBlock(), _createBlock(TaskDetails, {
                key: 0,
                form: form.value,
                onTaskListsx: taskListsx
              }, null, 8, ["form"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_el_dialog, {
        modelValue: batchShowTask.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((batchShowTask).value = $event)),
        "show-close": false,
        fullscreen: ""
      }, {
        header: _withCtx(({ close, titleId, titleClass }) => [
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createVNode(_component_el_icon, {
              class: "delicon",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (batchShowTask.value=false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Close)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          (batchTask.value)
            ? (_openBlock(), _createBlock(BatchAddTask, {
                key: 0,
                "project-id": taskid.value,
                onCancelTask: cancelBatchTask
              }, null, 8, ["project-id"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createVNode(_component_el_dialog, {
        modelValue: ganttShow.value,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((ganttShow).value = $event)),
        "show-close": false,
        fullscreen: ""
      }, {
        header: _withCtx(({ close, titleId, titleClass }) => [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createVNode(_component_el_icon, {
              class: "delicon",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (ganttShow.value=false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Close)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          (ganttShowInner.value)
            ? (_openBlock(), _createBlock(GanttChart, {
                key: ganttKey.value,
                projectid: taskid.value,
                onOpentask: openTaskFromGantt
              }, null, 8, ["projectid"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})